<template>
  <div>
    <el-button size="small" class="margin-bottom-10" type="primary" @click="toUnitAuth()" round
    ><i class="fa fa-plus"></i>
      机构授权
    </el-button>
    <el-table
        class="list-table"
        ref="multipleTable"
        :data="authList"
        border
        tooltip-effect="dark"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <template slot="empty">
        <div class="no-data">暂无数据！</div>
      </template>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="orgId" label="机构编号" width="120"></el-table-column>
      <el-table-column prop="orgName" label="机构名称" width="300"></el-table-column>
      <el-table-column prop="roles" label="角色" min-width="300">
        <template slot-scope="scope">
          <el-tag class="margin-right-5" size="small" effect="plain" v-for="(role, index) in scope.row.roles" :key="index">{{ role.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="130">
        <template slot-scope="scope">
          <el-button @click="toUnitAuth(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
          <el-button @click="deleteAuth(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <page-bar v-model="page" @change="fetchData"></page-bar>

    <el-dialog :title="curAuth ? '编辑机构授权' : '添加机构授权'" :visible.sync="dialogVisible" width="780px" :destroy-on-close="true" class="form-dialog">
      <el-form :rules="rules" ref="unitForm" label-width="80px">
        <el-form-item label="上级" name="parentId">
          <el-cascader :options="unitList" v-model="unitIds" :props="unitProps" change-on-select style="width: 53%"></el-cascader>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <template>
            <el-transfer v-model="roleIds" :props="props" :data="roleList" :titles="['角色名称', '配置角色']"></el-transfer>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
        <el-button type="primary" @click="saveUnitAuth()"><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchUnitAuth, remove } from '@/api/system/auth'
import PageBar from '@components/PageBar'
import { handleConfirm } from '@utils/confirm'
import { batchSaveUnitAuth } from '@/api/system/auth'
import { tree, get } from '@/api/system/unit'
import { fetchAll } from '@/api/system/role'

export default {
  created() {
    this.fetchData()
  },
  components: { PageBar },
  methods: {
    fetchData() {
      fetchUnitAuth({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        query: this.page.param
      }).then(resp => {
        this.authList = resp.data.result
      })
    },
    deleteAuth(val) {
      handleConfirm('你确定要回收该机构的所有授权吗, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    },
    toUnitAuth(row) {
      this.curAuth = row
      this.dialogVisible = true

      this.getUnitEcho()
      this.roleTransfer()
    },
    roleTransfer() {
      fetchAll().then(resp => {
        this.roleList = resp.data.result
      })
    },
    saveUnitAuth() {
      batchSaveUnitAuth(this.unitIds[this.unitIds.length - 1], this.roleIds).then(resp => {
        if (resp.status === 200) {
          this.$message.success(resp.data.message)
          this.fetchData()
          this.dialogVisible = false
        }
      })
    },
    doClose(){
      this.dialogVisible = false
    },
    getUnitEcho() {
      tree().then(resp => {
        this.unitList = resp.data.result

        if(this.curAuth){       //编辑时，回显机构和角色
          get(this.curAuth.orgId).then(resp => {
            let echoUnit = resp.data.result
            this.unitIds = echoUnit.parentIds.split(',').map(h => {
              return +h
            })
            this.unitIds.push(this.curAuth.orgId)
          })

          this.roleIds = this.curAuth.roles.map(r=> r.id)
        }else{
          this.unitIds = []
          this.roleIds = []
        }
      })
    }
  },
  data() {
    return {
      page: {
        pageSize: 20,
        pageNo: 1
      },
      curAuth: null,
      dialogVisible:false,
      roleIds: [],
      roleList: [],
      authList: [],
      unitList: [],
      unitIds: [],
      echoUnit: {},
      unitProps: {
        value: 'id',
        label: 'name',
        children: 'childrens'
      },
      props: {
        key: 'id',
        label: 'name'
      },
      rules: {
        name: [
          { required: true, message: '请选择机构', trigger: 'blur' },
          { min: 10, max: 20, message: '长度在 10 到 20 个字符', trigger: 'blur' }
        ],
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }]
      }
    }
  }
}
</script>

